export default {
  operationWasSuccessfull: 'Operation was successfull',
  pleaseConvertToValidPoint: 'please Convert ToValid Point',
  AreYouSureAboutTheOperation‌: 'Are You Sure About The Operation?‌',
  notificationType: 'Notification type',
  broadcast: 'Broadcast',
  multicast: 'Multicast',
  unicast: 'Unicast',
  expireTime: 'Expire time',
  silent: 'Silent',
  creationTime: 'Creation time',
  link: 'link',
  send: 'Send',
  sendDemo: 'Send demo',
  sender: 'Sender',
  contents: 'contents',
  event: 'Event',
  recipientMobile: 'Recipient mobile',
  recipientEmail: 'Recipient email',
  recipientKey: 'Recipient key',
  recipientAdmin: 'Recipient admin',
  recipientAnonymous: 'Recipient anonymous',
  gateway: 'Gateway',
  recipientDemo: 'Recipient demo',
  sentReport: 'Sent report',
  smsType: 'Sms type',
  unit: 'Unit',
  bulk: 'Bulk',
  emailType: 'Email type',
  internalType: 'Internal type',
  eventType: 'Event type',
  userOtpSend: 'User otp send',
  userRegister: 'User register',
  companyRegister: 'Courier register',
  shipmentCreateNotice: 'Order create notice',
  ShipmentCreateReminderInOfficeHour: 'Order create reminder in office hour',
  ShipmentCreateReminderOutOfficeHour: 'Order create reminder out office hour',
  ShipmentCancelNotice: 'Order cancel notice',
  ShipmentOfferCompanyAcceptNotice: 'Order Offer courier accept notice',
  ShipmentOfferCompanyPricingNotice: 'Order offer courier pricing notice',
  ShipmentOfferUserAcceptNotice: 'Order offer user accept notice',
  ShipmentAllOfferCanceledNotice: 'Order all offer canceled notice',
  ShipmentNoneOfferAcceptedNotice: 'Order none offer accepted notice',
  ShipmentAssignNotice: 'Order assign notice',
  ShipmentReassignNotice: 'Order reassign notice',
  DriverInitiateNotice: 'Driver initial notice',
  DriverDischargeNotice: 'Driver discharge notice',
  PropertyItemFeatureCreateNotice: 'Property item feature create notice',
  PropertyItemFeatureUpdateNotice: 'Property item feature update notice',
  PropertyEmployeeCreateNotice: 'Property employee create notice',
  PropertyEmployeeUpdateNotice: 'Property employee update notice',
  CarModelFeatureCreateNotice: 'Car model feature create notice',
  CarModelFeatureUpdateNotice: 'Car model feature update notice',
  FeedbackCreateNotice: 'Feedback create notice',
  deleted: 'Deleted',
  messageTitle: 'Message title',
  messageDescription: 'Message Description',
  notification: 'Notification',
  gatewayResponse: 'Gateway response',
  unsuccessfulDeliver: 'Unsuccessful deliver'
}
